import { StatusPillVariant } from '../../../shared/ui/status-pill/status-pill.component';
import { PaymentCardModel } from '../../../modules/finanzas/paymentcard/paymentcard.model';

export type PaymentCardExpiryStatus = 'none' | 'expired' | 'soon' | 'valid';

export interface PaymentCardExpiry {
  label: string;
  sort: number;
  status: PaymentCardExpiryStatus;
}

export interface PaymentCardRow extends PaymentCardModel {
  accountAssociated: string;
  expiring: string;
  expirySort: number;
  expiryStatus: PaymentCardExpiryStatus;
  __expanded?: boolean;
}

export const PAYMENT_CARD_SOON_MONTHS = 2;

export const CREDIT_CARD_MOVEMENT = {
  Disposicion: 1,
  Liquidacion: 2,
};

export function maskCardNumber(num: string): string {
  if (!num) return '';
  return num.replace(/\d{4}(?= \d{4})/g, '****');
}

export function normalizeExpiryYear(year: number): number {
  const value = Number(year) || 0;
  if (value <= 0) return 0;
  return value < 100 ? 2000 + value : value;
}

export function paymentCardExpiry(month: number, year: number, today: Date = new Date()): PaymentCardExpiry {
  const m = Number(month) || 0;
  const y = normalizeExpiryYear(year);
  if (m < 1 || m > 12 || !y) return { label: '', sort: 0, status: 'none' };
  const diff = (y * 12 + (m - 1)) - (today.getFullYear() * 12 + today.getMonth());
  const status: PaymentCardExpiryStatus = diff < 0 ? 'expired' : diff <= PAYMENT_CARD_SOON_MONTHS ? 'soon' : 'valid';
  return { label: `${m < 10 ? '0' + m : m}/${y}`, sort: y * 100 + m, status };
}

export function expiryBadgeVariant(status: PaymentCardExpiryStatus): StatusPillVariant {
  switch (status) {
    case 'expired': return 'danger';
    case 'soon': return 'warning';
    case 'valid': return 'success';
    default: return 'neutral';
  }
}

export function expiryBadgeLabel(label: string, status: PaymentCardExpiryStatus): string {
  switch (status) {
    case 'expired': return `Caducada · ${label}`;
    case 'soon': return `Caduca pronto · ${label}`;
    case 'valid': return label;
    default: return 'Sin caducidad';
  }
}

export function bankAccountLabel(bank: string, iban: string): string {
  return (bank || '') + (bank && iban ? ' / ' : '') + (iban || '');
}
